/**
 * Created by charnjeetelectrovese@gmail.com on 5/1/2020.
 */

import {
    APP_SETTINGS_UPDATE_GEOFENCE,
    APP_SETTINGS_DONE,
    APP_SETTINGS_INIT,
    APP_SETTINGS_CHANGE_THEME,
    APP_SETTINGS_UPDATE_POLICIES,
    APP_SETTINGS_UPDATE_APP_RULES,
    APP_SETTINGS_UPDATE_REFER_POINTS,
    APP_SETTINGS_UPDATE_VIDEO_CALL
} from "../actions/AppSettings.action";

const initialState = {
    error: false,
    is_calling: true,
    geofence: [],
    theme: 'dark',
    FAQ: '',
    CONTACT: '',
    TERMS: '',
    PRIVACY: '',
    ABOUT: '',
    RESTAURANT_ABOUT: '',
    is_auto_approve: false,
    is_reward: false,
    reward_value: 0,
    PAYMENT: '',
    DISCLAIMER: '',
    av_call: {
        video_call: false,
        audio_call: false,
    }
};

export default function (state = JSON.parse(JSON.stringify(initialState)), action) {
    switch (action.type) {
        case APP_SETTINGS_INIT: {
            return {...state, is_calling: true };
        }
        case APP_SETTINGS_DONE: {
            return {
                ...state,
                ...action.payload,
                is_calling: false
            }
        }
        case APP_SETTINGS_UPDATE_GEOFENCE: {
            if (action.payload) {
                return {...state, geofence: action.payload};
            }
        }
        case APP_SETTINGS_CHANGE_THEME: {
            if (action.payload) {
                return {...state, theme: action.payload};
            }
        }
        case APP_SETTINGS_UPDATE_POLICIES: {
            if (action.payload) {

                const { name, value } = action.payload;
                const data = JSON.parse(JSON.stringify(state));
                data[name] = value;
                return {
                    ...state,
                    ...data
                };
            }
        }
        case APP_SETTINGS_UPDATE_APP_RULES: {
            if (action.payload) {
                return {
                    ...state,
                    is_auto_approve: action.payload.is_auto_approve,
                    is_reward: action.payload.is_reward,
                    reward_value: action.payload.reward_value,
                };
            }
        }
        case APP_SETTINGS_UPDATE_REFER_POINTS: {
            if (action.payload) {
                const temp = action.payload;
                return {
                    ...state,
                    refer_points: temp.data
                };
            }
        }
        case APP_SETTINGS_UPDATE_VIDEO_CALL: {
            if (action.payload) {
                const temp = action.payload;
                return {
                    ...state,
                    av_call: temp.data
                };
            }
        }
        default: {
            return state;
        }
    }
    return state;
}
